import { css } from 'linaria';

export const downloadExampleButton = css`
  display: flex;
  align-items: center;
  padding: 0 10px;

  @media (--only-tablet) {
    margin-left: 48px;
  }

  &:focus,
  &:hover {
    background-color: var(--control-hover-minor);
    border-radius: var(--rounding-m);
  }
`;

export const downloadExampleIcon = css`
  width: 40px;
  height: 40px;
  margin-right: 8px;
`;

export const downloadExampleLabel = css`
  font-weight: 500;
`;
